import { combineReducers } from "redux";
import { account } from "./account/reducer";
import obterUsuario from "./actions/obterUsuario";

export const auth = combineReducers({
  account,
  obterUsuario
});
